import React from 'react';
import DataTable from '../components/DataTable';
import { KTSVG } from '../../_metronic/helpers';
import 'react-loading-skeleton/dist/skeleton.css';
import { Link } from 'react-router-dom';
import { deleteRequestOptions } from '../helpers/Fetchwrapper';
import Swal from 'sweetalert2';

function ItemStockAdjustment() {
    const hasPermission = 1;

    const deleteStockAdjustment = (id: number) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'You will not be able to recover this stock adjustment!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Yes, delete it!',
            cancelButtonText: 'No, keep it',
            showLoaderOnConfirm: true,
            customClass: {
                confirmButton: 'btn btn-danger me-2',
                cancelButton: 'btn btn-secondary'
            },
            preConfirm: () => {
                return fetch(process.env.REACT_APP_API_URL + 'item-stock-adjustment/' + id, deleteRequestOptions())
                    .then(response => response.json())
                    .then(data => {
                        if (!data.success) {
                            throw new Error(data.errorMessage || 'Failed to delete');
                        }
                        return data;
                    })
                    .catch(error => {
                        Swal.showValidationMessage(error.message || 'Request failed');
                    });
            }
        }).then((result) => {
            if (result.isConfirmed && result.value?.success) {
                Swal.fire('Deleted!', result.value.successMessage || 'Stock adjustment has been deleted.', 'success');
                window.location.reload();
            }
        });
    };

    const columns = [
        { value: 'id', title: 'ID', style: { textAlign: 'center' } },
        { value: 'projectName', title: 'Project', style: { textAlign: 'left' } },
        { value: 'warehouseName', title: 'Warehouse', style: { textAlign: 'left' } },
        { value: 'adjustmentType', title: 'Adjustment Type', style: { textAlign: 'left' } },
        { value: 'adjustmentDate', title: 'Date', style: { textAlign: 'left' } },
        { value: 'remarks', title: 'Remarks', style: { textAlign: 'left' } },
        { value: 'createdBy', title: 'Created By', style: { textAlign: 'left' } },
        {
            value: 'action',
            title: 'Action',
            style: { textAlign: 'left', whiteSpace: 'nowrap' },
            hasActionsComponent: true,
            actionsComponent: (row: any) => (
                <>
                    <Link
                        to={`/item-stock-adjustment-details/${row.id}`}
                        className="btn btn-light-primary btn-sm px-2 py-1 me-1"
                    >
                        <KTSVG path='/media/svg/icons/General/Visible.svg' className='svg-icon-5 svg-icon' />
                        Details
                    </Link>
                    <button
                        className="btn btn-light-danger btn-sm px-2 py-1"
                        onClick={() => deleteStockAdjustment(row.id)}
                    >
                        <KTSVG path='/media/svg/icons/General/Trash.svg' className='svg-icon-5 svg-icon' />
                        Delete
                    </button>
                </>
            )
        }
    ];

    const filters = {
        id: { filterType: 'like', filterValue: '' },
        projectName: { filterType: 'like', filterValue: '' },
        warehouseName: { filterType: 'like', filterValue: '' },
        adjustmentType: { filterType: 'like', filterValue: '' },
        adjustmentDate: { filterType: 'like', filterValue: '' },
        remarks: { filterType: 'like', filterValue: '' },
        createdBy: { filterType: 'like', filterValue: '' },
        action: { filterType: 'like', filterValue: '' },
    };

    const url = process.env.REACT_APP_API_URL + 'item-stock-adjustment/dt';

    return (
        <>
            {hasPermission === 1 && (
                <div className='card card-custom'>
                    <div className='card-header'>
                        <div className="card-title">
                            <KTSVG path='/media/svg/icons/Text/Bullet-list.svg' className='svg-icon-1 svg-icon-primary' />
                            <span className='text fw-bolder' style={{ marginLeft: '10px' }}>
                                Stock Adjustment List
                            </span>
                        </div>
                        <div className="card-toolbar">
                            <div className='d-flex justify-content-end'>
                                <Link to="/item-stock-adjustment-create" className="btn btn-sm btn-primary">
                                    <i className="fa fa-plus"></i> Create New Adjustment
                                </Link>
                            </div>
                        </div>
                    </div>
                    <div className='card-body'>
                        <DataTable url={url} columns={columns} filters={filters} />
                    </div>
                </div>
            )}
        </>
    );
}

export default ItemStockAdjustment;
